"use client";
import { VerifyEmailEnforcementProvider } from "@/components/VerifyEmailEnforcement";
import AdsContextProvider from "@/context/AdsContext";
import AppContextProvider from "@/context/AppContext";
import { UserContextProvider } from "@/context/UserContext";
import { useAPI } from "@/lib/api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import { SWRConfig } from "swr";

// import { AppProgressProvider as ProgressProvider } from "@bprogress/next";

export default function Providers({
  children,
  locale,
  kind = "HOME",
  host = "",
}) {
  return (
    <AppContextProvider value={{ kind: kind as any, locale, host }}>
      {/* <ProgressProvider
        height="4px"
        color="hsl(var(--primary))"
        options={{ showSpinner: false }}
        shallowRouting
      > */}
      <GoogleOAuthProvider
        clientId={process.env.NEXT_PUBLIC_GOOGLE_APPID || ""}
      >
        <SWRProvider>
          <Toaster
            containerStyle={{
              zIndex: 999999999,
            }}
            toastOptions={{
              className:
                "!bg-background !border !border-secondary !text-foreground !text-sm",
            }}
          />
          <UserContextProvider>
            <AdsContextProvider ads={{ enabled: true, placement: {} }}>
              <VerifyEmailEnforcementProvider>
                {children}
              </VerifyEmailEnforcementProvider>
            </AdsContextProvider>
          </UserContextProvider>
        </SWRProvider>
      </GoogleOAuthProvider>
      {/* </ProgressProvider> */}
    </AppContextProvider>
  );
}

function SWRProvider({ children }) {
  const api = useAPI();
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: true,
        revalidateOnMount: true,
        refreshWhenHidden: false,
        fetcher: async (url) => await api.get(url),
      }}
    >
      {children}
    </SWRConfig>
  );
}
